module.exports = __webpack_public_path__ + "static/Erudex Logo -02-f174f94ff862a21a1ef224b314abeb1c.png";